import React from 'react';
import { Box, Typography, Paper } from '@mui/material';
const BackendResponseCodeMapping: React.FC = React.memo(() => {

    return (
        <Box sx={{ mt: 2 }}>
        <Paper sx={{
            borderRadius: '4px',
            overflow: 'hidden'
        }}>
            <Box sx={{ p: 2 }}>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
                    {/* Common Response Codes */}
                    <Box>
                        <Typography variant="subtitle1" sx={{ mb: 2, color: "#0b3452", fontWeight: "bold" }}>
                            Common Response Codes
                        </Typography>
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
                            <Box>
                                <Typography sx={{ mb: 0.5, fontWeight: 'medium' }}>
                                    <code>F200</code> - Success
                                </Typography>
                            </Box>
                            <Box>
                                <Typography sx={{ mb: 0.5, fontWeight: 'medium' }}>
                                    <code>F400</code> - Bad request
                                </Typography>
                            </Box>
                            <Box>
                                <Typography sx={{ mb: 0.5, fontWeight: 'medium' }}>
                                    <code>F401</code> - Unauthorized
                                </Typography>
                            </Box>
                            <Box>
                                <Typography sx={{ mb: 0.5, fontWeight: 'medium' }}>
                                    <code>F402</code> - Session Error
                                </Typography>
                            </Box>
                            <Box>
                                <Typography sx={{ mb: 0.5, fontWeight: 'medium' }}>
                                    <code>F403</code> - User Mismatched
                                </Typography>
                            </Box>
                            <Box>
                                <Typography sx={{ mb: 0.5, fontWeight: 'medium' }}>
                                    <code>F404</code> - Record not found
                                </Typography>
                            </Box>
                            <Box>
                                <Typography sx={{ mb: 0.5, fontWeight: 'medium' }}>
                                    <code>F405</code> - Invalid FIU
                                </Typography>
                            </Box>
                            <Box>
                                <Typography sx={{ mb: 0.5, fontWeight: 'medium' }}>
                                    <code>F406</code> - Invalid FIP
                                </Typography>
                            </Box>
                            <Box>
                                <Typography sx={{ mb: 0.5, fontWeight: 'medium' }}>
                                    <code>F407</code> - FIP Failure
                                </Typography>
                            </Box>
                            <Box>
                                <Typography sx={{ mb: 0.5, fontWeight: 'medium' }}>
                                    <code>F408</code> - User Mismatched
                                </Typography>
                            </Box>
                            <Box>
                                <Typography sx={{ mb: 0.5, fontWeight: 'medium' }}>
                                    <code>F429</code> - Max attempts exceeded
                                </Typography>
                            </Box>
                            <Box>
                                <Typography sx={{ mb: 0.5, fontWeight: 'medium' }}>
                                    <code>F500</code> - Internal server error
                                </Typography>
                            </Box>
                        </Box>
                    </Box>

                    {/* Auth Flow Error Codes */}
                    <Box>
                        <Typography variant="subtitle1" sx={{ mb: 2, color: "#0b3452", fontWeight: "bold" }}>
                            Auth Flow Error Codes
                        </Typography>
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
                            <Box>
                                <Typography sx={{ mb: 0.5, fontWeight: 'medium' }}>
                                    <code>A001</code> - Invalid login user format
                                </Typography>
                            </Box>
                            <Box>
                                <Typography sx={{ mb: 0.5, fontWeight: 'medium' }}>
                                    <code>A002</code> - User session not found
                                </Typography>
                            </Box>
                            <Box>
                                <Typography sx={{ mb: 0.5, fontWeight: 'medium' }}>
                                    <code>A003</code> - OTP Initiation Failed
                                </Typography>
                            </Box>
                            <Box>
                                <Typography sx={{ mb: 0.5, fontWeight: 'medium' }}>
                                    <code>A004</code> - Login OTP verification failed
                                </Typography>
                            </Box>
                            <Box>
                                <Typography sx={{ mb: 0.5, fontWeight: 'medium' }}>
                                    <code>A005</code> - Invalid OTP
                                </Typography>
                            </Box>
                            <Box>
                                <Typography sx={{ mb: 0.5, fontWeight: 'medium' }}>
                                    <code>A006</code> - Invalid OTP Reference
                                </Typography>
                            </Box>
                        </Box>
                    </Box>

                    {/* Discovery & Linking Flow Error Codes */}
                    <Box>
                        <Typography variant="subtitle1" sx={{ mb: 2, color: "#0b3452", fontWeight: "bold" }}>
                            Discovery & Linking Flow Error Codes
                        </Typography>
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
                            <Box>
                                <Typography sx={{ mb: 0.5, fontWeight: 'medium' }}>
                                    <code>D001</code> - User ID mismatch with the requested user
                                </Typography>
                            </Box>
                            <Box>
                                <Typography sx={{ mb: 0.5, fontWeight: 'medium' }}>
                                    <code>D002</code> - Unsupported financial information type
                                </Typography>
                            </Box>
                            <Box>
                                <Typography sx={{ mb: 0.5, fontWeight: 'medium' }}>
                                    <code>D003</code> - Device not authenticated
                                </Typography>
                            </Box>
                            <Box>
                                <Typography sx={{ mb: 0.5, fontWeight: 'medium' }}>
                                    <code>D004</code> - Email not authenticated
                                </Typography>
                            </Box>
                            <Box>
                                <Typography sx={{ mb: 0.5, fontWeight: 'medium' }}>
                                    <code>D005</code> - Aadhar not authenticated
                                </Typography>
                            </Box>
                            <Box>
                                <Typography sx={{ mb: 0.5, fontWeight: 'medium' }}>
                                    <code>D006</code> - Authenticator required for this operation
                                </Typography>
                            </Box>
                            <Box>
                                <Typography sx={{ mb: 0.5, fontWeight: 'medium' }}>
                                    <code>D007</code> - Invalid Financial Information Provider (FIP)
                                </Typography>
                            </Box>
                            <Box>
                                <Typography sx={{ mb: 0.5, fontWeight: 'medium' }}>
                                    <code>D008</code> - FIP operation failed
                                </Typography>
                            </Box>
                            <Box>
                                <Typography sx={{ mb: 0.5, fontWeight: 'medium' }}>
                                    <code>D009</code> - Account already linked
                                </Typography>
                            </Box>
                            <Box>
                                <Typography sx={{ mb: 0.5, fontWeight: 'medium' }}>
                                    <code>D010</code> - No linked accounts found
                                </Typography>
                            </Box>
                            <Box>
                                <Typography sx={{ mb: 0.5, fontWeight: 'medium' }}>
                                    <code>D011</code> - Account reference number not found in linked accounts
                                </Typography>
                            </Box>
                        </Box>
                    </Box>

                    {/* Consent Flow Error Codes */}
                    <Box>
                        <Typography variant="subtitle1" sx={{ mb: 2, color: "#0b3452", fontWeight: "bold" }}>
                            Consent Flow Error Codes
                        </Typography>
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
                            <Box>
                                <Typography sx={{ mb: 0.5, fontWeight: 'medium' }}>
                                    <code>C001</code> - Consent expired
                                </Typography>
                            </Box>
                            <Box>
                                <Typography sx={{ mb: 0.5, fontWeight: 'medium' }}>
                                    <code>C002</code> - Consent already actioned
                                </Typography>
                            </Box>
                            <Box>
                                <Typography sx={{ mb: 0.5, fontWeight: 'medium' }}>
                                    <code>C003</code> - Record not found
                                </Typography>
                            </Box>
                            <Box>
                                <Typography sx={{ mb: 0.5, fontWeight: 'medium' }}>
                                    <code>C004</code> - Consent denied by user
                                </Typography>
                            </Box>
                            <Box>
                                <Typography sx={{ mb: 0.5, fontWeight: 'medium' }}>
                                    <code>C005</code> - Invalid or malformed consent
                                </Typography>
                            </Box>
                            <Box>
                                <Typography sx={{ mb: 0.5, fontWeight: 'medium' }}>
                                    <code>C006</code> - User mismatch
                                </Typography>
                            </Box>
                            <Box>
                                <Typography sx={{ mb: 0.5, fontWeight: 'medium' }}>
                                    <code>C007</code> - FIU mismatch
                                </Typography>
                            </Box>
                            <Box>
                                <Typography sx={{ mb: 0.5, fontWeight: 'medium' }}>
                                    <code>C008</code> - Invalid linked account
                                </Typography>
                            </Box>
                            <Box>
                                <Typography sx={{ mb: 0.5, fontWeight: 'medium' }}>
                                    <code>C009</code> - Consent handle not found
                                </Typography>
                            </Box>
                            <Box>
                                <Typography sx={{ mb: 0.5, fontWeight: 'medium' }}>
                                    <code>C010</code> - Consent handle required
                                </Typography>
                            </Box>
                        </Box>
                    </Box>
                </Box>
            </Box>
        </Paper>
    </Box>
    );
});

export default BackendResponseCodeMapping;
